{{ 'Project::ProjectImportedSuccessfully' | abpLocalization }}
<i>{{ notification.project }}</i>
